<template>
  <table class="mtable">
    <TableHeader :cols="cols" :line="line"> </TableHeader>
    <TableTr
      v-for="(item, index) in currentdata"
      :key="index"
      :data="item"
      :cols="cols"
      :style="'text-align:' + align"
      :myindex="index + 1"
      :line="line"
      :class="index % 2 ? 'stripe' : ''"
    >
    </TableTr>
  </table>
</template>

<script>
import TableHeader from "./TableHeader.vue";
import TableTr from "./TableTr.vue";
export default {
  components: {
    TableHeader,
    TableTr,
  },
  props: {
    cols: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    align: {
      type: String,
      default: "left",
    },
    stripe: {
      type: Boolean,
      default: false,
    },
    line: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    currentdata: function () {
      return this.data.slice(0).sort(function (a, b) {
        return new Date(a.date) > new Date(b.date);
      });
    },
  },
  methods: {},
  created() {},
};
</script>

<style lang="less" scoped>
.mtable {
  width: 100%;
  max-height: 80vh;
  overflow-y: scroll;
  border-collapse: collapse;
  padding: 1rem;
  background: #fff;
  margin: 1rem 0;
  box-shadow: 5px 5px 10px #d5d5d5;
  .stripe {
    background: #fafafa;
  }
}
</style>
